import React from "react"
import styled from "styled-components"

import { VerticalSection } from "components/common"

import NewsLetterForm from "components/forms/NewsLetterForm"

// import { FeaturedBlogPost, BlogPosts } from "./"
import { BlogPosts } from "./"

const BlogPostsHero = ({ title, hat, subtitle, components }) => {
  // const { featured_blog_post } = useContentfulComponent(components)

  return (
    <StyledBlogPostsHero>
      <VerticalSection
        hat={hat}
        title={title}
        titleAs="h1"
        subtitle={subtitle}
        custom={() => (
          <div className="">
            <NewsLetterForm />
            {/* <FeaturedBlogPost {...featured_blog_post.blogPost} /> */}
            <BlogPosts />
          </div>
        )}
      />
    </StyledBlogPostsHero>
  )
}

const StyledBlogPostsHero = styled.div`
  --section-padding-top: var(--sp-nav);
  --section-mobile-padding-top: var(--sp-mobile-nav);
  --tg-max-width: 900px;

  .customWrap {
    margin-top: var(--sp-16);
  }

  .blogPostsList {
    margin-top: var(--sp-80);
  }
`

export default BlogPostsHero
